module.exports = __webpack_public_path__ + "img/repguide-screenshot-wartung.e2cb1f17.png";